// extracted by mini-css-extract-plugin
export default {"awatar":"Register_awatar__5qDnd","awatarBox":"Register_awatarBox__HW88V","awatarSlide":"Register_awatarSlide__w2Jlc","fade-up":"Register_fade-up__2OV+M"};